'use client';

import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Paper
} from "@mui/material";

import { useTranslations } from 'next-intl';

const Content = () => {
    const t = useTranslations('SctPage.Content');

    const rows = [
        { label: t('row1_label'), value: t('row1_value') },
        { label: t('row2_label'), value: t('row2_value') },
        { label: t('row3_label'), value: t('row3_value') },
        { label: t('row4_label'), value: t('row4_value') },
        { label: t('row5_label'), value: t('row5_value') },
        { label: t('row6_label'), value: t('row6_value') },
        { label: t('row7_label'), value: t('row7_value') },
        { label: t('row8_label'), value: t('row8_value') },
        { label: t('row9_label'), value: t('row9_value') },
        { label: t('row10_label'), value: t('row10_value') },
        { label: t('row11_label'), value: t('row11_value') },
    ];
    return (
        <TableContainer component={Paper} elevation={0} sx={{ border: "1px solid #e2e8f0", borderRadius: "16px", marginBottom: 8 }}>
            <Table sx={{ minWidth: 280 }} aria-label="specified commercial transaction table">
                <TableBody>
                    {rows.map((row, index) => (
                        <TableRow
                            key={row.label}
                            sx={{
                                '&:last-child td, &:last-child th': { border: 0 },
                                backgroundColor: index % 2 === 0 ? '#f8fafc' : 'white'
                            }}
                        >
                            <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                    width: { xs: '35%', sm: '30%' },
                                    fontWeight: "bold",
                                    color: "#1e293b",
                                    backgroundColor: "#f1f5f9",
                                    borderBottom: "1px solid #e2e8f0",
                                    whiteSpace: "pre-wrap"
                                }}
                            >
                                {row.label}
                            </TableCell>
                            <TableCell
                                align="left"
                                sx={{
                                    color: "#334155",
                                    borderBottom: "1px solid #e2e8f0",
                                    whiteSpace: "pre-wrap"
                                }}
                            >
                                {row.value}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default Content;